var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2918 17.1139C13.8371 17.1139 17.9652 10.8611 17.9652 5.44044C17.9652 5.26466 17.9613 5.08497 17.9535 4.90919C18.7566 4.32844 19.4496 3.6091 20 2.78497C19.2521 3.11772 18.458 3.33504 17.6449 3.4295C18.5011 2.91632 19.1421 2.11012 19.4492 1.16036C18.6438 1.63769 17.763 1.9744 16.8445 2.15607C16.2257 1.49853 15.4075 1.06316 14.5164 0.917267C13.6253 0.77138 12.711 0.9231 11.9148 1.34897C11.1186 1.77484 10.4848 2.45115 10.1115 3.27332C9.73825 4.09549 9.64619 5.01774 9.84961 5.89747C8.21874 5.81563 6.62328 5.39198 5.16665 4.65397C3.71002 3.91597 2.42474 2.88009 1.39414 1.61349C0.870333 2.51659 0.710047 3.58526 0.945859 4.6023C1.18167 5.61934 1.79589 6.50843 2.66367 7.08888C2.01219 7.0682 1.37498 6.89279 0.804688 6.57716V6.62794C0.804104 7.57568 1.13175 8.49438 1.73192 9.22787C2.3321 9.96135 3.16777 10.4644 4.09687 10.6514C3.49338 10.8165 2.85999 10.8406 2.2457 10.7217C2.50788 11.5368 3.01798 12.2496 3.70481 12.7608C4.39164 13.272 5.22093 13.5561 6.07695 13.5733C4.62369 14.7148 2.82848 15.334 0.980469 15.3311C0.652739 15.3306 0.325333 15.3105 0 15.2709C1.87738 16.4753 4.06128 17.115 6.2918 17.1139Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.71cda7fb1b9d8ba2f60ffd9c364771cf.svg";
export { ForwardRef as ReactComponent };